import { render, staticRenderFns } from "./SetupPoin.vue?vue&type=template&id=6d198174"
import script from "./SetupPoin.vue?vue&type=script&lang=js"
export * from "./SetupPoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports